export const ChangePasswordClickActions = {
  START: 'start',
  REQUEST: 'request',
  SUBMIT: 'submit',
};

export type ChangePasswordClickActionTypes =
  (typeof ChangePasswordClickActions)[keyof typeof ChangePasswordClickActions];

export const LOGIN_CLICK_TEXT = 'Sign in';
export const LoginSuccessStates = {
  FAILURE: 'failure',
  SUCCESS: 'success',
};

export type LoginSuccessStateTypes =
  (typeof LoginSuccessStates)[keyof typeof LoginSuccessStates];

export const InviteNewUserActions = {
  NEW_USER: 'new_user',
  INVITE: 'invite',
  CANCEL: 'cancel',
};

export type InviteNewUserActionTypes =
  (typeof InviteNewUserActions)[keyof typeof InviteNewUserActions];

export const MainNavigationClickActions = {
  LOGO: 'logo',
  DASHBOARD: 'dashboard',
  PROJECT_MAP: 'project_map',
  COMPANY_INSIGHTS: 'company_insights',
  INVITE_USER: 'invite_user',
  HELP_CENTER: 'help_center',
  ACCOUNT_DROPDOWN: 'account_dropdown',
  LOGOUT: 'logout',
  ACCOUNT_SETTINGS: 'account_settings',
  HELP_AND_RESOURCES: 'help_and_resources',
  SHARE_FEEDBACK: 'share_feedback',
  BOOK_SESSION: 'book_session',
  PRODUCT_UPDATES: 'product_updates',
  REQUEST_A_FEATURE: 'request_a_feature',
  FILING_SEARCH: 'filing_search',
  ASK_SCOUT: 'ask_scout',
} as const;

export type MainNavigationClickActionTypes =
  (typeof MainNavigationClickActions)[keyof typeof MainNavigationClickActions];

export const MainNavigationClickLocations = {
  HEADER: 'header',
  ACCOUNT_DROPDOWN: 'account_dropdown',
  HELP_AND_RESOURCES_DROPDOWN: 'help_and_resources_dropdown',
} as const;

export type MainNavigationClickLocationTypes =
  (typeof MainNavigationClickLocations)[keyof typeof MainNavigationClickLocations];

export const SecondaryNavigationClickActions = {
  DASHBOARD__SAVED_SEARCHES: 'saved_searches',
  DASHBOARD__COMPANY_GROUPS: 'company_groups',
  DASHBOARD__SAVED_PROJECTS: 'saved_projects',
  DASHBOARD__SHARED_PROJECTS: 'shared_projects',
  ACCOUNT_SETTINGS__MY_PROFILE: 'my_profile',
  ACCOUNT_SETTINGS__NOTIFICATIONS: 'notifications',
  ACCOUNT_SETTINGS__USERS: 'users',
  ACCOUNT_SETTINGS__BILLING: 'billing',
  ACCOUNT_SETTINGS__INTEGRATIONS: 'integrations',
  COMPANY_INSIGHTS__PROJECTS: 'projects',
  COMPANY_INSIGHTS__TRENDS: 'trends',
  COMPANY_INSIGHTS__CONTACTS: 'contacts',
};

export type SecondaryNavigationClickActionTypes =
  (typeof SecondaryNavigationClickActions)[keyof typeof SecondaryNavigationClickActions];

export const SecondaryNavigationClickLocations = {
  DASHBOARD__LEFT_STATIC_NAV: 'dashboard__left_static_nav',
  ACCOUNT_SETTINGS__LEFT_STATIC_NAV: 'account_settings__left_static_nav',
  COMPANY_INSIGHTS__TABS: 'company_insights__tabs',
} as const;

export type SecondaryNavigationClickLocationTypes =
  (typeof SecondaryNavigationClickLocations)[keyof typeof SecondaryNavigationClickLocations];

export const ExportProjectListGroupTypes = {
  PROJECT_GROUP: 'project_group',
  COMPANY_GROUP: 'company_group',
  COLLECTION: 'collection',
  SHARED_COLLECTION: 'shared_collection',
  UNCATEGORIZED: 'uncategorized',
};

export type ExportProjectListGroupTypeTypes =
  (typeof ExportProjectListGroupTypes)[keyof typeof ExportProjectListGroupTypes];

export const ExportProjectListSuccessStates = {
  SENT: 'sent',
  SUCCESS: 'success',
};

export type ExportProjectListSuccessStateTypes =
  (typeof ExportProjectListSuccessStates)[keyof typeof ExportProjectListSuccessStates];

export const ProjectGroupTypes = {
  COLLECTION: 'collection',
  COMPANY_GROUP: 'company_group',
  COMPANY_PROJECTS: 'company_projects',
  PROJECT_GROUP: 'project_group',
  PROJECT_MAP: 'project_map',
  SHARED_COLLECTION: 'shared_collection',
  OTHER_PROJECTS: 'other_projects',
  UNCATEGORIZED: 'uncategorized',
};

export type ProjectGroupTypeTypes =
  (typeof ProjectGroupTypes)[keyof typeof ProjectGroupTypes];

export const ViewProjectDetailsClickLocations = {
  MAP: 'map',
  LIST: 'list',
  SUMMARY_CARD: 'summary_card',
  UNCATEGORIZED: 'uncategorized',
};

export type ViewProjectDetailsClickLocationTypes =
  (typeof ViewProjectDetailsClickLocations)[keyof typeof ViewProjectDetailsClickLocations];

export const SavedProjectsPageViewSections = {
  SAVED_PROJECTS: 'saved_projects',
};

export const ViewStageDetailsClickLocations = {
  PDP: 'project_detail_page',
  PPC: 'project_preview_card',
};

export type ViewStageDetailsClickLocationTypes =
  (typeof ViewStageDetailsClickLocations)[keyof typeof ViewStageDetailsClickLocations];

export const MapClickClickActions = {
  MAP_CLUSTER: 'map_cluster',
  MAP_MARKER: 'map_marker',
  PARCEL_POLYGON: 'parcel_polygon',
};

export type MapClickClickActionTypes =
  (typeof MapClickClickActions)[keyof typeof MapClickClickActions];

export const SavedProjectsPageViewSubSections = {
  HOME: 'home',
};

export const SharedProjectsPageViewSections = {
  SHARED_PROJECTS: 'shared_projects',
};

export const SharedProjectsPageViewSubSections = {
  HOME: 'home',
};

export const SavedSearchesPageViewSections = {
  SAVED_SEARCHES: 'project_groups',
};

export const SavedSearchesPageViewSubSections = {
  HOME: 'home',
};

export const NewSavedSearchPageViewSections = {
  NEW_SEARCH: 'new_project_group_config',
};

export const NewSavedSearchPageViewSubSections = {
  NEW_SEARCH: 'new_saved_search_start',
};

export const EditSavedSearchPageViewSections = {
  EDIT_SEARCH: 'edit_project_group_config',
};

export const EditSavedSearchPageViewSubSections = {
  EDIT_GROUP: 'edit_group__',
};

export const CompanyGroupsPageViewSections = {
  COMPANY_GROUPS: 'company_groups',
};

export const CompanyGroupsPageViewSubSections = {
  HOME: 'home',
  IMPORT: 'import',
};

export const ProjectMapPageViewSections = {
  PROJECT_MAP: 'project_map',
};

export const ProjectDetailsPageViewSections = {
  PROJECT_DETAILS: 'project_details',
};

export const ProjectDetailsPageViewSubSections = {
  MENU: 'menu',
};

export const ProjectNotesClickActions = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  UNDO_DELETE: 'undo_delete',
  START_EDIT: 'start_edit',
  CANCEL_EDIT: 'cancel_edit',
} as const;

export type ProjectNotesClickActionTypes =
  (typeof ProjectNotesClickActions)[keyof typeof ProjectNotesClickActions];

export const CompanyInsightsPageViewSections = {
  COMPANY_DIRECTORY: 'company_directory',
};

export const DocumentSearchPageViewSections = {
  FILING_SEARCH: 'document_search',
  DOCUMENT_TABLE: 'document_table',
};

export const CompanyDetailsPageViewSections = {
  COMPANY_DETAILS: 'company_details',
};

export const CompanyDetailsPageViewSubSections = {
  COMPANY_INFORMATION: 'company_information',
};

export const LoginPageViewSections = {
  LOGIN: 'login',
};

export const LoginPageViewSubSections = {
  LOGIN: 'login',
};

export const AccountPageViewSections = {
  ACCOUNT_SETTINGS: 'account_settings',
};

export const AccountPageViewSubSections = {
  OVERVIEW: 'overview',
};

export const ScountAgentChatViewSections = {
  SCOUT_AGENT_PAGE: 'scout_agent_page',
};

export const DocumentViewSections = {
  DOCUMENT_MODAL: 'document_modal',
};
